import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39085592")

_pushScopeId("data-v-39085592")
const _hoisted_1 = /*#__PURE__*/_createVNode("svg", {
  class: "mx-auto fill-current",
  width: "24px",
  height: "24px",
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 75.294 75.294",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createVNode("g", null, [
    /*#__PURE__*/_createVNode("path", { d: "M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9\n\t\tc5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089\n\t\tH61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065\n\t\tc0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016\n\t\tc0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102\n\t\tc0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069\n\t\tc0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z" })
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-2xs -mt-1" }, "Mail", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "mx-auto fill-current",
  width: "24px",
  height: "24px",
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 75.294 75.294",
  style: {"enable-background":"new 0 0 75.294 75.294"},
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createVNode("g", null, [
    /*#__PURE__*/_createVNode("path", { d: "M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9\n\t\tc5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089\n\t\tH61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065\n\t\tc0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016\n\t\tc0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102\n\t\tc0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069\n\t\tc0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z" })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-2xs -mt-1" }, "Mail", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.channelSelected || (!_ctx.selectedChannel || !_ctx.selectedChannel.length))
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          class: "items-center text-gray-400",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectMailAsChannel && _ctx.selectMailAsChannel(...args)))
        }, [
          _hoisted_1,
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    (_ctx.channelSelected || _ctx.channelSelected)
      ? (_openBlock(), _createBlock("button", {
          key: 1,
          class: "items-center text-gray-900 dark:text-gray-100",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectMailAsChannel && _ctx.selectMailAsChannel(...args)))
        }, [
          _hoisted_3,
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ], 64))
})